import TLNfbBtn from '../images/TLN_fbBtn400.jpg';

function TLNfbBtnEmbed(){
    return (
        <>
        <img src={TLNfbBtn} alt="True Liberty North Facebook Button" className="faithImage embedRound" />
        </>
    );
};
export default TLNfbBtnEmbed;